export class ManualRegistry{
    FolderName: string;
    Title: string;
    CreatedBy: number;
    ModifiedBy: number;
    CreatedOn: string;
    ModifiedOn: string;
}
